export default [
    {
        name: 'tag',
        type: 'text-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Nombre',
            // rules: [required],
        },
    },
    {
        name: 'description',
        type: 'text-field',
        flex: {
            sm6: true,
            lg6: true,
        },
        props: {
            label: 'Descripción',
            // rules: [required],
        },
    },
]
